var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.dialogVisible,
        width: "1060px",
        height: "680px",
        "close-on-click-modal": false,
        "custom-class": "privacy-dialog",
        "before-close": _vm.handleClose,
        "show-close": true,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "span",
        {
          staticStyle: {
            color: "#3855F1",
            "font-family":
              "'Inter Tight', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
            "font-size": "22px",
            "font-weight": "600",
            "line-height": "normal",
          },
          attrs: { slot: "title" },
          slot: "title",
        },
        [_vm._v("Terms of Service — Indo")]
      ),
      _c("div", { staticClass: "services-agreements-page" }, [
        _c("div", { staticClass: "container" }, [
          _c("p", [
            _vm._v(
              'PayCools Terms of Service for Users (the "Terms") constitutes a legally binding agreement between PayCools HongKong Limited, a company incorporated under the laws of HongKong (the "Company"), and any User of the PayCools Service ("User") which has engaged the Company to provide the Services by the Company (each a "Party" and collectively, "Parties").'
            ),
          ]),
          _c("p", [
            _vm._v(
              'This User Terms governs the Company\'s provision of payment services (collectively, the "Services") to the User, for the amounts (the "Transaction Amounts") due by them to the User for their purchase of goods, services and/or digital content ("Goods and Services") ("Transaction").'
            ),
          ]),
          _c("p", [
            _vm._v(
              'In the event that the Services are provided by any company which is affiliated to PayCools HongKong Limited ("PayCools Affiliate") then this Terms shall constitute a contract between such PayCools Affiliate and the User and PayCools Affiliate will be the party responsible for the provision of the Services in accordance with this Terms. The reference to "Company" or "we" in this Terms shall be read as a reference to PayCools HongKong Limited or PayCools Affiliate as the case may be.'
            ),
          ]),
          _c("p", [
            _vm._v(
              "The User acknowledges and agrees to comply with this Terms on and from the date that the User submits application to the Company to use the Services and agrees to cease using the Services immediately if the User does not agree to any of this Terms. By using or continuing to use the Services, the User accepts and agrees to be bound by this Terms as well as any subsequent revisions and modifications hereto."
            ),
          ]),
          _c("h3", [_vm._v("1. Application, review and commencement of use")]),
          _c("ol", [
            _c("li", [
              _vm._v(
                "A User may apply to use the Services provided by the Company pursuant to the procedures established by the Company from time to time. By applying to engage the Services provided by the Company, the User agrees to accept and be bound by this Terms as well as other terms and policies of the Company."
              ),
            ]),
            _c("li", [
              _vm._v(
                "The User shall provide all essential information as may be required by the Company to the Company when applying to use the Services provided."
              ),
            ]),
            _c("li", [
              _vm._v(
                "The Company may require further information from the User which it deems necessary in connection with the application to use the Services. The User hereby warrants and represents that all the information that it provides to the Company is accurate, complete and up-to-date. The User shall forthwith notify the Company of any changes to the information provided by the User to the Company. If the User fails to provide notification to the Company of any changes to the information previously provided by it in a timely manner, or the information provided by the User is incorrect or untrue, then the Company may reject the Application, suspend and/or terminate the provision of all or part thereof of the Services to the User without further notice. The User shall be solely liable for any consequence of submitting any incorrect, untrue, or incomplete information, or delaying submission."
              ),
            ]),
            _c("li", [
              _vm._v(
                "The Company shall have the sole discretion to determine whether or not to approve the Application submitted by the User to engage the Services of the Company and shall not be obligated to disclose the review process to any applicant. The Company shall not be held liable for any loss or damage arising from an applicant's failure to pass the review process."
              ),
            ]),
            _c("li", [
              _vm._v(
                'The User will create its own account ("Service Account") and password for its use of the Services. The User may use the Services upon receiving approval of the Application by the Company and after the User has created its Service Account.'
              ),
            ]),
          ]),
          _c("h3", [_vm._v("2. USER'S AGREEMENT")]),
          _c("ol", [
            _c("li", [
              _vm._v(
                "The Company shall provide the Services with reasonable care and skill and in accordance with all applicable laws and regulations (including this Terms and Privacy Policy)."
              ),
            ]),
            _c("li", [
              _vm._v(
                "The User acknowledges and agrees that it is only entitled to use the Services to receive payment of Transaction Amounts approved in advance by the Company and so notified in writing to the User from time to time."
              ),
            ]),
            _c("li", [
              _vm._v(
                "The User acknowledges and agrees that any relationship between the User and the other User in terms of its rights and obligations in connection with the Transactions, the Transaction methods and terms, and performance or non-performance of the Transactions (including but not limited to refusal to perform, delay, non-delivery, defects, errors, return or replacement of Goods and Services, and refund) exist only between the User and the User. All rights, obligations and liabilities with respect to such Transactions shall be exercised, fulfilled, and borne by the User and the User in accordance to applicable laws and regulations and the terms of their agreements. The Company is only responsible for conducting Transaction verification and providing payment of all or part thereof of the Transaction Amounts due from the User to the User in accordance with the applicable laws and regulations and this Terms as well as other Terms applicable."
              ),
            ]),
            _c("li", [
              _vm._v(
                "The User agrees that the Company in providing the Services does not act as principal but merely as a facilitator on behalf of the User to enable the User to enter into Transactions with other Users. The User waives any claims against the Company whether for the performance or non-performance of any Transaction entered into as a consequence of the Company's provision of Services to the User."
              ),
            ]),
            _c("li", [
              _vm._v(
                "The User shall solely assume all legal responsibilities and obligations arising (i) by virtue of its contractual relationship with other Users, including without limitation any rights and obligations, warranties against defects, and intellectual property rights asserted between the User and other Users, and/or (ii) under any applicable laws and regulations in force from time to time. If the Company incurs any loss, damage, cost or liability as a result of the User's failure to duly discharge its legal responsibilities and obligations under this Clause 2.5, the User shall immediately and unconditionally compensate the Company and/or indemnify and keep indemnified the Company against any such loss, damage, cost or liability."
              ),
            ]),
            _c("li", [
              _vm._v(
                "The Company shall have the right to check the Goods and Services transacted or the services by the User. If required, the User is obligated to describe details of such Goods and Service and indicate other related matters (such as additional expenses, the delivery, etc.) to the Company and shall ensure the correctness of the documents filed to support requests for payment."
              ),
            ]),
            _c("li", [
              _vm._v(
                "If the Users (including the payor and the recipient) agree to revoke, cancel or terminate any Transactions, or change the Goods and Services purchased or the Transaction price after the Company has paid the relevant Transaction Amounts to the recipient, the recipient and payor shall immediately notify the Company of the relevant information regarding such revocation, cancellation or the termination of the Transactions or such change, and provide the Company with a refund note and the relevant supporting documents, within a refund period in accordance with Company's refund policy, by email or in writing if requested by the Company. For the avoidance of doubt, the recipient shall not refund the price of Goods and Services to the payor in cash directly except such refund note is not provided to the Company within the refund period in accordance with Company's refund policy."
              ),
            ]),
            _c("li", [
              _vm._v(
                "The User agrees to co-operate with the Company and allow the Company or its representatives or agents to carry out audits, reviews or inspections (including but not limited to examination of Transaction records, transaction anomalies, and any relevant credit, compliance or risk-related records maintained by the User or any relevant credit reporting or information authority), and to assist the Company in connection with any related matters."
              ),
            ]),
            _c("li", [
              _vm._v(
                "The User shall join the Company in preventing illegal or suspicious or fraudulent Transactions and co-operate with the Company in handling related matters."
              ),
            ]),
          ]),
          _c("h3", [_vm._v("3. SAFEKEEPING OF TRANSACTION RECORDS")]),
          _c("p", [
            _vm._v(
              "The User acknowledges and agrees that where the User has not retained any documentations in relation to any Transactions then records kept by the Company in relation to such Transactions shall be deemed to be true and accurate."
            ),
          ]),
          _c("h3", [_vm._v("4. ACCOUNT INFORMATION AND PAYMENT PROCEDURE")]),
          _c("ol", [
            _c("li", [
              _vm._v(
                'When the payment conditions agreed upon between the Company and the User are fulfilled, the Company shall pay the Transaction Amounts receivable by User to a valid bank account of the User as required to be maintained in accordance with Clause 9 ("User\'s Bank Account"), which the User has provided when applying for use of the Services, after deducting the various charges receivable by the Company.'
              ),
            ]),
            _c("li", [
              _vm._v(
                "All charges for payment to the User in connection with the Services, including, but not limited to the payment of the Transaction Amounts receivable by the User, shall be paid or borne by the User, regardless of whether or not the Transaction is revoked, cancelled or terminated. For the avoidance of doubt, the Company shall, in no event, return or refund such charges to the User."
              ),
            ]),
            _c("li", [
              _vm._v(
                "The User shall be responsible for its acts in connection with its Service Account. The Service Account shall not be assigned, given away, or inherited. If the User decides not to renew its contract with the Company, it shall apply to the Company for cancellation of its Service Account."
              ),
            ]),
            _c("li", [
              _vm._v(
                "The Company is entitled to hold the payment payable to User if the Company, at its sole discretion, has the reasonable ground to believe that User may or will ceases to carry on business or the User may or will becomes insolvent or any step is taken for User liquidation, winding-up, bankruptcy, receivership, administration or dissolution (or anything analogous to the foregoing occurs in any jurisdiction) and/or the Company receives any notification from any courts of law or other competent authority or the Customer regarding any dispute of the payment of Transaction Amounts before the Company pay the relevant Transaction Amounts to Users."
              ),
            ]),
            _c("li", [
              _vm._v(
                "The Company will record all of the Users' operations of the Services, regardless whether such operations are valid or not. The User may inquire about records of its transactions under their Service Accounts with the Services through the management interface provided by the Company. If the User finds any erroneous records, it may request that the Company provide the records of the instructions to collect or pay the amounts at issue. The User understands and agrees that after the Company pays the amounts specified by the User to its User's Bank Account according to the User's instructions, and the financial institution partnered with the Company thereafter confirms that the amounts have been duly received, the Company shall be deemed to have performed its obligation to make the payments under this User Terms. If the User has any questions about such payments, it shall direct such enquiries to the financial institutions where its User's Bank Account is held at."
              ),
            ]),
          ]),
          _c("h3", [_vm._v("5. USER'S RESPONSIBILITY FOR RETURN OF FUNDS")]),
          _c("ol", [
            _c("li", [
              _vm._v(
                "The User agrees that in any of the following situations, it will return the amounts paid by the Company to it so that the Company will not sustain losses, and that the Company may deduct such amounts to be returned from other sums payable by the Company to User in the following circumstances:"
              ),
            ]),
            _c("ul", [
              _c("li", [
                _vm._v(
                  "The User has breached this Terms, or financial institutions inform the Company that the User's transactions are risky, illegal, suspicious, or are in violation of the applicable laws or regulations."
                ),
              ]),
              _c("li", [
                _vm._v(
                  "The User conducts Transactions for other stores or persons, or settle accounts with, and claim payments, from the Company from means other than through the Services provided by the Company."
                ),
              ]),
              _c("li", [
                _vm._v(
                  "The Company asks the User to provide the records related to a Transaction for the former's review, but the User fails to provide the same within seven days of receipt of the Company's notice."
                ),
              ]),
            ]),
          ]),
          _c("h3", [_vm._v("6. FAIR TREATMENT")]),
          _c("p", [
            _vm._v(
              "The User shall not, under any circumstances, limit or exempt its liability by requiring any other user using the Service to waive their right to raise any argument or dispute, or to waive their right to claim for the User's responsibility for any damages incurred by the other user due to the purchase or use of Goods and Services between the User and the other user using the Service."
            ),
          ]),
          _c("h3", [_vm._v("7. Assistance in Investigation")]),
          _c("ol", [
            _c("li", [
              _vm._v(
                "The Company may demand the User to provide a report and/or information on any Transaction, performance statuses of any sale and purchase agreements, and any other information that the Company deems necessary for the investigations into the User's use of the Services. The User is not permitted to resist such requests for such report and/or information."
              ),
            ]),
            _c("li", [
              _vm._v(
                "The Company may demand that the User provide any information and/or documents that is necessary for the compliance with laws and regulations. The User shall provide such information and/or documents promptly."
              ),
            ]),
          ]),
          _c("h3", [_vm._v("8. Service Charges")]),
          _c("ol", [
            _c("li", [
              _vm._v(
                'In return for the Company\'s provision of the Services, the User shall pay to the Company such services charges as may be applicable and notified to the User from time to time ("Service Charges"). The terms and conditions of the payment of the Service Charges are set out in the Application.'
              ),
            ]),
            _c("li", [
              _vm._v(
                "Unless stated otherwise, all Services Charges and other payments to be made by the User under this User Terms to the Company are exclusive of Value Added Tax, stamp duty and any other relevant taxes and in addition to paying such Service Charges or other payments, the User agrees to also pay all of such foregoing taxes, including penalty, surcharge, fine and any governmental charges thereof."
              ),
            ]),
            _c("li", [
              _vm._v(
                "The Company may from time to time vary the Service Charges and/or introduce new charges in addition to the fees by giving the User not less than 7 days' notice."
              ),
            ]),
            _c("li", [
              _vm._v(
                "The Company reserves the right to suspend any of the Services in its sole and absolute discretion and without notice and/or terminate this User Terms in accordance with Clause 15 if the User does not pay any of the amounts due to the Company from time to time within the specified period."
              ),
            ]),
          ]),
          _c("h3", [_vm._v("9. Bank account and payments")]),
          _c("ol", [
            _c("li", [
              _vm._v(
                'The User shall throughout the term of the User Terms and for such period as may be required thereafter for the purposes of any applicable provisions of the User Terms maintain in its name a bank account that is acceptable to the Company for the purposes of receiving payments from the Company and making payments to the Company ("User\'s Bank Account").'
              ),
            ]),
            _c("li", [
              _vm._v(
                "Where it is possible for the Company to debit the User's Bank Account the Company shall be entitled to debit all sums due to it from the User pursuant to the terms under this User Terms by direct debit from the User's Bank Account and the Company in exercising its right to do so shall not prejudice any other rights or remedies it may have. The User shall maintain with its bank an instruction to authorise such debits."
              ),
            ]),
            _c("li", [
              _vm._v(
                "The User shall notify the Company in advance of any changes proposed by the User in respect of the User's Bank Account (including, without limitation, the location of the branch at which such account is held). Such changes shall take effect only upon the Company's confirmation."
              ),
            ]),
          ]),
          _c("h3", [_vm._v("10. INTELLECTUAL PROPERTY")]),
          _c("p", [
            _vm._v(
              "The User agrees and acknowledges that nothing in these the User Terms shall constitute the grant of any right, title or interest in or to any intellectual property rights used in connection with or comprised in the Services, all of which rights are retained by Company and its licensors."
            ),
          ]),
          _c("h3", [_vm._v("11. CONFIDENTIALITY")]),
          _c("ol", [
            _c("li", [
              _vm._v(
                'The User acknowledges that, in the course of using the Services, it may obtain access to certain non-public, proprietary or confidential information relating to the Company, including but not limited to the User Terms, business operations, technical information, commercial information, and any Personal Data ("Confidential Information").'
              ),
            ]),
            _c("li", [
              _vm._v(
                "The User shall keep all Confidential Information strictly confidential and shall not use or disclose such Confidential Information for any purpose other than the proper use of the Services, unless otherwise permitted by the Company in writing or required by applicable law. The User shall take reasonable measures to prevent any unauthorised use or disclosure of Confidential Information."
              ),
            ]),
            _c("li", [
              _vm._v(
                "The confidentiality obligations under this Clause shall not apply to information which:"
              ),
            ]),
            _c("ul", [
              _c("li", [
                _vm._v(
                  "is or becomes publicly available other than through a breach of these User Terms;"
                ),
              ]),
              _c("li", [
                _vm._v(
                  "is lawfully obtained by the User from a third party without breach of any confidentiality obligation; or"
                ),
              ]),
              _c("li", [
                _vm._v(
                  "is required to be disclosed by applicable law or by a competent authority, provided that such disclosure is limited to the extent legally required."
                ),
              ]),
            ]),
            _c("li", [
              _vm._v(
                "This Clause shall survive the termination or expiry of these User Terms."
              ),
            ]),
          ]),
          _c("h3", [_vm._v("12. PERSONAL DATA")]),
          _c("ol", [
            _c("li", [
              _vm._v(
                "The User acknowledges and agrees that, in connection with the use of the Services, the User and the Company may collect, use, disclose and otherwise process Personal Data in accordance with applicable laws and the Company's Privacy Policy, as updated from time to time."
              ),
            ]),
            _c("li", [
              _vm._v(
                "To the extent that any Personal Data is disclosed or made available by the Company to the User in connection with the Services, the User shall: (a) process such Personal Data solely for the purposes for which it was provided; (b) comply with all applicable laws and regulations relating to personal data; and (c) implement reasonable technical and organisational measures to protect such Personal Data against unauthorised or unlawful access, use, disclosure, loss or destruction."
              ),
            ]),
            _c("li", [
              _vm._v(
                "The User shall promptly notify the Company upon becoming aware of any actual or suspected unauthorised access to, use or disclosure of Personal Data and shall reasonably cooperate with the Company in connection with any investigation or remedial actions."
              ),
            ]),
            _c("li", [
              _vm._v(
                "To the extent that the User provides any Personal Data to the Company, the User represents and warrants that it has obtained all necessary rights, authorities and consents for such disclosure and for the Company's collection, use and disclosure of such Personal Data in accordance with the Company's Privacy Policy."
              ),
            ]),
          ]),
          _c("h3", [_vm._v("13. DISPUTES")]),
          _c("ol", [
            _c("li", [
              _vm._v(
                "In the event of any dispute, controversy or claim of whatever nature arising out of or in connection with the User's use of the Services, the Parties shall first seek to resolve such dispute through good faith internal communications and consultations."
              ),
            ]),
            _c("li", [
              _vm._v(
                "If the dispute cannot be resolved through such internal resolution within a reasonable period of time, either Party may submit the dispute to the courts of the Indonesia, which shall have exclusive jurisdiction."
              ),
            ]),
            _c("li", [
              _vm._v(
                "For the purposes of resolving any such dispute or claim, the records and transaction data maintained by the Company and the User pursuant to this Agreement may be referred to as supporting materials. Where discrepancies arise between the records of the Company and those of the User, the Parties shall reasonably cooperate to investigate such discrepancies using information from both Parties where appropriate. If such discrepancies cannot be reconciled after reasonable efforts, the records of the Company shall prevail."
              ),
            ]),
            _c("li", [
              _vm._v(
                "The Parties further agree that this Agreement and the User Terms shall not, by themselves, constitute evidence adverse to either Party solely by reason of their form or standardised nature."
              ),
            ]),
          ]),
          _c("h3", [_vm._v("14. Warranties/indemnities/Liabilities")]),
          _c("ol", [
            _c("li", [
              _vm._v(
                "User Indemnity. The User shall defend, indemnify and hold harmless the Company and its related parties from any claims, losses, damages, costs or liabilities (including reasonable legal fees) arising out of or in connection with: (a) any breach of the User Terms or Policies by the User or its personnel; (b) any claim arising from the relationship between the Parties; or (c) the Company's enforcement of, or protection of its rights under, these User Terms."
              ),
            ]),
            _c("li", [
              _vm._v(
                "Control of Defence. Where any claim is brought against the Company by a card issuer or any third party, the Company shall be entitled to manage, settle or otherwise deal with such claim at its discretion."
              ),
            ]),
            _c("li", [
              _vm._v(
                "Joint and Several Liability. Where the User is a partnership, each partner shall be jointly and severally liable for all obligations under the User Terms."
              ),
            ]),
            _c("li", [
              _vm._v(
                'Disclaimer of Warranties. The Services are provided on an "AS IS" and "AS AVAILABLE" basis. To the maximum extent permitted by law, the Company disclaims all warranties, whether express or implied, including any warranties of accuracy, reliability, merchantability, fitness for a particular purpose and non-infringement.'
              ),
            ]),
            _c("li", [
              _vm._v(
                "Exclusion of Certain Losses. To the maximum extent permitted by law, the Company shall not be liable for any indirect, incidental, special, consequential or punitive losses, including loss of profits, revenue, data, goodwill or business opportunities."
              ),
            ]),
            _c("li", [
              _vm._v(
                "Non-excludable Liability. Nothing in these User Terms shall exclude or limit liability for death or personal injury caused by negligence, fraud or any liability which cannot be excluded by law."
              ),
            ]),
            _c("li", [
              _vm._v(
                "Liability Cap. The total aggregate liability of the Company arising out of or in connection with the Services shall not exceed the total Service Charges paid by the User to the Company in the 3 (three) months preceding the event giving rise to the claim."
              ),
            ]),
          ]),
          _c("h3", [_vm._v("15. Terms and Termination")]),
          _c("ol", [
            _c("li", [
              _vm._v(
                "These User Terms shall commence on the date the User submits an application for, or otherwise accesses or uses, the Services and shall continue until terminated in accordance with this Clause."
              ),
            ]),
            _c("li", [
              _vm._v(
                "Where the Company notifies the User that the User's application for the Services has not been accepted, these User Terms shall terminate with immediate effect upon such notification."
              ),
            ]),
            _c("li", [
              _vm._v(
                "Notwithstanding the foregoing, the Company may, at its discretion, suspend or terminate all or part of the Services with immediate effect by notice to the User if: (a) the User breaches these User Terms or fails to make any payment when due; (b) the User becomes insolvent, enters liquidation, bankruptcy, restructuring, or makes arrangements with creditors; (c) the Company reasonably considers that the User's financial condition, business conduct, refund or chargeback levels, trading practices, control structure or overall risk profile may adversely affect the Company, the Services, or any third party; (d) any claim, dispute or third-party action arises in connection with the User or the Services; or (e) the Company is required or requested to do so by any card scheme, issuer, acquirer, bank, financial institution or regulatory authority."
              ),
            ]),
            _c("li", [
              _vm._v(
                "In connection with the termination of this Agreement, the Parties agree to set aside the application of the provisions of Article 1266 of the Civil Code, insofar as these provisions require a decision or determination by a judge or court to terminate an agreement, so that termination of this Agreement for the reasons as set out in this Article can be legally done by written notification from one of the Parties."
              ),
            ]),
          ]),
          _c("h3", [_vm._v("16. CONSEQUENCES OF TERMINATION")]),
          _c("ol", [
            _c("li", [
              _vm._v(
                "Upon termination of the User Terms, all rights and obligations of the Parties shall immediately cease, except that:"
              ),
            ]),
            _c("ul", [
              _c("li", [
                _vm._v(
                  "any provision which by its nature or express wording is intended to survive termination shall remain in full force and effect; and"
                ),
              ]),
              _c("li", [
                _vm._v(
                  "termination shall not affect any rights, remedies, obligations or liabilities of either Party which have accrued prior to the effective date of termination."
                ),
              ]),
            ]),
            _c("li", [
              _vm._v(
                "Upon or at any time after termination, the User shall immediately pay to the Company all outstanding amounts payable under the User Terms. For the avoidance of doubt, the Company shall remain entitled to withhold, deduct, set off and recover any sums in accordance with the User Terms and applicable law."
              ),
            ]),
          ]),
          _c("h3", [
            _vm._v("17. Relationships with other Terms and Conditions"),
          ]),
          _c("ol", [
            _c("li", [
              _vm._v(
                "In addition to the User Terms, the User's use of the Services shall also be subject to other PayCools Terms."
              ),
            ]),
            _c("li", [
              _vm._v(
                "Unless expressly provided for under relevant terms, in case of any inconsistency between the User Terms and other PayCools Terms, the User Terms shall prevail."
              ),
            ]),
          ]),
          _c("h3", [_vm._v("18. General Terms")]),
          _c("ol", [
            _c("li", [
              _vm._v(
                "Entire Agreement. Without prejudice to Clause above, the User Terms constitutes the entire agreement and understanding between the Parties in respect of the matters dealt with in it and supersedes and invalidates all other prior representations, arrangements, understandings and agreements relating to the subject matter of the User Terms which may have been made between the Parties either orally or in writing prior to the date of the User Terms."
              ),
            ]),
            _c("li", [
              _vm._v(
                "The Company may amend, modify or update these User Terms from time to time by providing written or electronic notice to the User. Unless otherwise stated by the Company, such amendments shall become effective upon the date specified in the notice. The User's continued access to or use of the Services after the effective date of any amendment shall constitute the User's deemed acceptance of the amended User Terms."
              ),
            ]),
            _c("li", [
              _vm._v(
                "If any provision of these User Terms is determined by any court or competent authority to be illegal, invalid or unenforceable, such provision shall, to the extent required, be severed or modified, and the remaining provisions shall continue in full force and effect. Where possible, such provision shall apply with the minimum modification or deletion necessary to render it legal, valid and enforceable."
              ),
            ]),
            _c("li", [
              _vm._v(
                "The Company may assign, transfer or novate these User Terms and any of its rights or obligations thereunder by written notice to the User. The User shall not assign, transfer, sublicense or otherwise dispose of any of its rights or obligations without the Company's prior written consent."
              ),
            ]),
            _c("li", [
              _vm._v(
                "Any notice, communication or notification provided by the Company to the User under these User Terms shall be given by way of in-platform notification through the Company's system, dashboard, website or other online interface designated by the Company from time to time."
              ),
            ]),
            _c("li", [
              _vm._v(
                "Any failure or delay by the Company in exercising any right shall not constitute a waiver of that right."
              ),
            ]),
            _c("li", [
              _vm._v(
                "No person other than the Parties shall have any right to enforce any provision of these User Terms."
              ),
            ]),
            _c("li", [
              _vm._v(
                "Any translation is for convenience only. In the event of inconsistency, the English version shall prevail."
              ),
            ]),
            _c("li", [
              _vm._v(
                "The formation, construction, performance, validity and all matters arising out of or in connection with these User Terms shall be governed by and construed in accordance with the laws of Indonesia. The Parties irrevocably submit to the exclusive jurisdiction of the courts of Indonesia."
              ),
            ]),
          ]),
          _c("div", { staticClass: "revision-date" }, [
            _c("p", [
              _vm._v(
                "The latest revision of this Terms is dated 12 January 2026."
              ),
            ]),
          ]),
        ]),
      ]),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              staticStyle: {
                "background-color": "#3855F1",
                color: "#ffffff",
                width: "120px",
                padding: "12px",
                height: "34px",
              },
              attrs: { type: "text" },
              on: { click: _vm.handleClose },
            },
            [_vm._v("Close")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }